angular.module('picmonicng').directive('ccNumber', [
  function () {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        ctrl.$validators['cc-number'] = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            return false;
          }

          if (/[^0-9-\s]+/.test(viewValue)) return false;

          // The Luhn Algorithm. It's so pretty.
          var nCheck = 0,
            nDigit = 0,
            bEven = false;
          viewValue = viewValue.replace(/\D/g, '');

          for (var n = viewValue.length - 1; n >= 0; n--) {
            var cDigit = viewValue.charAt(n),
              nDigit = parseInt(cDigit, 10);

            if (bEven) {
              if ((nDigit *= 2) > 9) nDigit -= 9;
            }

            nCheck += nDigit;
            bEven = !bEven;
          }

          return nCheck % 10 == 0;
        };
      },
    };
  },
]);
